import React from 'react'

function RentalAgreement() {
  return (
    <div>RentalAgreement</div>
  )
}

export default RentalAgreement